import SVG from './SVG'
import * as T from './types'

const CollapsibleDownChevron = (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox="0 0 8 6"
    d="M7.06 0.530029L4 3.58336L0.94 0.530029L0 1.47003L4 5.47003L8 1.47003L7.06 0.530029Z"
  />
)

export { CollapsibleDownChevron }
